import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'ScenarioPreview'

export const GET_PREVIEW_ASYNC = createAsyncTypes('GET_PREVIEW', typeKey)
export const REPORT_TO_TEMPLATE_ASYNC = createAsyncTypes('REPORT_TO_TEMPLATE', typeKey)
export const FETCH_PROFILES_SUGGESTIONS_ASYNC = createAsyncTypes(
  'FETCH_PROFILES_SUGGESTIONS',
  typeKey
)
export const TEST_SCENARIO_ASYNC = createAsyncTypes('TEST_SCENARIO', typeKey)

export const SET_SCENARIO_PREVIEW_SWITCHER = `${typeKey}/SET_SCENARIO_PREVIEW_SWITCHER`
export const SET_PRESELECTED_LOCAL_ID = `${typeKey}/SET_PRESELECTED_LOCAL_ID`
export const RESET_MANAGER = `${typeKey}/RESET_MANAGER`
